"use es6";

import { PromiseObservable } from './PromiseObservable';
export const fromPromise = PromiseObservable.create;